import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { LocalStorageKeys } from "@service/LocalStorageService";
import { buildRoute } from "@util/RouteUtil";
import LoadingView from "../../features/virtual-space/components/SpaceView/LoadingView/LoadingView";

const DEFAULT_REDIRECT_TIMEOUT_MS = 1000;

interface LoadingRedirectPageProps {
    readonly preventRedirect?: boolean;
    readonly redirectTimeoutMs?: number;
}
export default function LoadingRedirectPage(props: LoadingRedirectPageProps) {
    const history = useHistory();

    const [showLoading, setShowLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!props.preventRedirect) {
            const t = setTimeout(() => {
                setShowLoading(false);
                window.sessionStorage.setItem(LocalStorageKeys.IsFirstVisitToLifeAtV2, "false");
                history.push(buildRoute(Routes.App)); // redirect user to the main app
            }, props.redirectTimeoutMs ?? DEFAULT_REDIRECT_TIMEOUT_MS);

            return () => clearTimeout(t);
        }
        return undefined;
    }, [props.preventRedirect]);

    return (
        <div className={"info-page redirect-page"}>
            <LoadingView isAppLoading={showLoading} />
        </div>
    );
}
